import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ds-card-body',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<p class="ds-card-body"><ng-content /></p>`,
  styles: [`
    .ds-card-body {
      font-size: 14px;
      line-height: 1.6;
      margin: 0;
      color: currentColor;
      opacity: 0.85;
    }
  `],
})
export class DsCardBodyComponent {}
